import React from 'react';
import { FC } from 'react';

// project imports
import { NaraCellarLogo } from '../components/icons';

// material-ui
import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/router';

type FooterProps = {
  color: string;
};

const Footer: FC<FooterProps> = ({ color = '#FFF' }) => {
  const router = useRouter();

  // 개인정보 처리방침 페이지 이동
  const goPrivacyPolicy = () => {
    router.push('/policy/privacy');
  };

  // 서비스 이용약관 페이지 이동f
  const goServicePolicy = () => {
    router.push('/policy/service');
  };

  // render
  return (
    <footer>
      <Box sx={{ bgcolor: color }}>
        <Container>
          <Box pt={4} pb={6} overflow="hidden">
            <Box pb="36px">
              <Stack
                direction="row"
                spacing="12px"
                divider={
                  <Box display="flex" alignItems="center" pb="1px">
                    <Box height="14px" width="2px" bgcolor="#D5D2D2" />
                  </Box>
                }
                sx={{ fontSize: 11, fontWeight: 300 }}
              >
                <Typography
                  sx={{ fontSize: 16, fontWeight: 800, color: '#6A6A6A', lineHeight: 'normal', cursor: 'pointer' }}
                  onClick={goServicePolicy}
                >
                  서비스 이용약관
                </Typography>
                <Typography
                  sx={{ fontSize: 16, fontWeight: 800, color: '#6A6A6A', lineHeight: 'normal', cursor: 'pointer' }}
                  onClick={goPrivacyPolicy}
                >
                  개인정보 처리방침
                </Typography>
              </Stack>
            </Box>

            <Grid container borderTop="1px solid #D5D2D2" py="36px" spacing={2}>
              <Grid item xs={12} md={4} sm={3} lg={2}>
                <NaraCellarLogo />
              </Grid>
              <Grid item xs={12} md={8} sm={9} lg={10}>
                <Stack spacing={1.5}>
                  <Typography sx={{ color: '#6A6A6A', fontSize: 16, lineHeight: 'normal' }}>
                    경기도 이천시 마장면 프리미엄아울렛로 33-48, 에이동
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    <Typography sx={{ color: '#6A6A6A', fontSize: 16, lineHeight: 'normal', fontWeight: 700 }}>
                      고객센터
                    </Typography>
                    <Typography sx={{ color: '#6A6A6A', fontSize: 16, lineHeight: 'normal' }}>02-405-4300</Typography>
                  </Stack>
                </Stack>

                <Box pt="36px">
                  <Typography
                    variant="body2"
                    sx={{ fontSize: 16, color: 'rgba(106, 106, 106, 0.80)', fontWeight: 400, lineHeight: 'normal' }}
                  >
                    COPYRIGHTⓒ NARA CELLAR {new Date().getFullYear()} ALL RIGHTS RESERVED.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </footer>
  );
};

export default Footer;
